let pathname = window.location.pathname.substring(1).split('/')

let userID = pathname[0]
let productID = pathname[1]
let apiUrl = process.env.VUE_APP_API_URL || null

export const facilita = {
    gstoken: 'f31195d4230af66e9ed83fa1e615f133',
    gstokenuser: 'eyJpdiI6IldZYlwvSFFWcG5ydXE4bEhkUjlrMUhBPT0iLCJ2YWx1ZSI6ImZrakkrb2JRTHlIR05cL0c3WFh3ZFdhZVwvMSswV0VKMmd6U1N1N2lLOTZ5NGZZc2tBMzlESjlWM1A5dEs4N200QWkycGZnZm5FQVp6a2lpcjJjTzBuSGc9PSIsIm1hYyI6IjAxMDUzMmQyNjFlYmIwZGIzNjU0YWVhOWI0ZjVlZjhlNTdjNDk0ZGI2NmE2OTQ0MWJmMzQ2MmI4N2UwZmEwYzYifQ==',
    panel: '/',
    api: 'https://marketplace.api.facilitavendas.com/api/v1/',
	newApi: 'https://api.meucorretor.digital/api/v1/',
    apiOff: process.env.NODE_ENV === 'development' ? `${apiUrl}/api/v1/offline/` : `${apiUrl}/api/v1/offline/`,
    gtmID: 'GTM-5HRQXZS',
    productID: productID,
    userID: userID,
}
